<template>
  <button class="w-6 h-6 rounded transition-all flex justify-center items-center hover:bg-gray-100" v-tooltip="notShowTooltip ? '' : tooltip" @click="$emit('click')">
    <svg class="w-3 h-3"
         viewBox="0 0 170.08 170.08" xml:space="preserve"
         :fill="fillColor"
    >
      <path d="M103.071,85.04l63.273-63.273c4.981-4.979,4.981-13.052,0-18.031c-4.981-4.981-13.05-4.981-18.031,0
        L85.04,67.009L21.767,3.736c-4.981-4.981-13.049-4.981-18.031,0c-4.981,4.979-4.981,13.052,0,18.031L67.009,85.04L3.736,148.313
        c-4.981,4.979-4.981,13.052,0,18.031c2.491,2.49,5.753,3.736,9.016,3.736c3.262,0,6.525-1.246,9.015-3.736L85.04,103.07
        l63.273,63.274c2.491,2.49,5.753,3.736,9.015,3.736c3.263,0,6.525-1.246,9.016-3.736c4.981-4.979,4.981-13.052,0-18.031
        L103.071,85.04z"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'GrmCloseBtn',
  props: {
    tooltip: { type: String,  default: function () {return this.$t('common.close')} },
    notShowTooltip: { type: Boolean, default: false },
    color: { type: String, default: 'black' },
  },
  computed: {
    fillColor() {
      switch (this.color) {
        case 'white': return '#fff';
        case 'black': return '#000';
        case 'info': return '#1d4ed8';
        case 'success': return '#15803d';
        case 'warning': return '#a16207';
        case 'error': return '#b91c1c';
        default : return '#000';
      }
    }
  }
}
</script>